import React from 'react';

const Breadcrumb = ({ path }: { path: string }) => {
    // Split the path by "/" and filter out any empty strings
    const pathArray = path.split('/').filter(Boolean);

    return (
        <nav className="text-md font-medium text-gray-500 pt-4 px-3 md:px-7 lg:px-14">
            <ol className="list-reset flex">
                {pathArray.map((part: string, index: number) => {
                    // Create a full path up to the current segment
                    const fullPath = `/${pathArray.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathArray.length - 1;

                    return (
                        <li key={index} className="flex items-center">
                            {/* Conditionally render links for everything except the last item */}
                            {!isLast ? (
                                <>
                                    <a href={fullPath} className="text-green-600 hover:underline">
                                        {part}
                                    </a>
                                    <span className="mx-2">→</span> {/* Breadcrumb separator */}
                                </>
                            ) : ''}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
